module.exports = __webpack_public_path__ + "img/surakshitha_logo.357a19de.webp";